import { useEffect, useState } from 'react';
import { PreventionsByYearPerMonth } from '../../../types/types';

interface UsePreventionDataResult {
  preventionsByYearPerMonth: PreventionsByYearPerMonth | null;
  loading: boolean;
  error: string | null;
}

/**
 * Fetches prevention/response data on mount — same pattern as
 * useEvictionsData. NEEDS CONFIRMATION: the endpoint path below is a
 * placeholder guess; swap it for the real route this data actually
 * comes from.
 */
export function usePreventionData(): UsePreventionDataResult {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [preventionsByYearPerMonth, setPreventionsByYearPerMonth] =
    useState<PreventionsByYearPerMonth | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPrevention = async () => {
      try {
        setLoading(true);
        setError(null);

        const res = await fetch(`${BASE_URL}/prod_eviction_stats/`); // TODO: confirm real path
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }

        const data = await res.json();
        setPreventionsByYearPerMonth(data.preventionsByYearPerMonth);
      } catch (err) {
        console.error(err);
        setError(err instanceof Error ? err.message : 'Failed to load data');
      } finally {
        setLoading(false);
      }
    };

    fetchPrevention();
  }, []);

  return { preventionsByYearPerMonth, loading, error };
}